import { render } from "./TransactionBanner.vue?vue&type=template&id=4237e728"
import script from "./TransactionBanner.vue?vue&type=script&lang=js"
export * from "./TransactionBanner.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__